import ListByEvent from '@/brain/event-documents/ListByEvent'
import ViewDocument from '@/brain/event-documents/ViewDocument'
import ShowPdfDocument from '@/brain/event-documents/ShowPdfDocument'
import RemoveDocumentById from '@/brain/event-documents/RemoveDocumentById'

import {
  navigatorState,
  navigatorGetters,
  navigatorMutations } from '@/components/primitives/paginator/stored-navigator-store'
import { ResetState } from '@/state/utils'

const defaultState = () => ({
  ...navigatorState({ perPage: 6 }),
  documentList: [],
  formFilter: {
    documentTypeId: null,
    description: null
  },
  showPdfDocument: false
})

const getters = {
  ...navigatorGetters(),
  DOCUMENT_LIST: (state) => state.documentList,
  SHOW_PDF_DOCUMENT: (state) => state.showPdfDocument
}
const mutations = {
  ...navigatorMutations(),
  RESET_STATE: (state) => ResetState(state, defaultState),
  DOCUMENT_LIST: (state, documentList) => { state.documentList = documentList },
  FORM_FILTER: (state, formFilter) => { state.formFilter = formFilter },
  SHOW_PDF_DOCUMENT: (state, status) => { state.showPdfDocument = status }
}
const actions = {
  LIST_BY_EVENT: ListByEvent,
  VIEW_DOCUMENT: ViewDocument,
  SHOW_PDF_DOCUMENT: ShowPdfDocument,
  REMOVE_DOCUMENT_BY_ID: RemoveDocumentById
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/event-documents/state/index.js